import { OnInit, Component, AfterViewInit, Renderer2, Inject, SimpleChanges, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { LocalizationService } from '@services/localization.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@pipes/translate.pipe';
import { EasyPasswordEnabled, environment } from '@environments/environment';
import { pushToDataLayer } from '@helpers/gtm.util';
import { DOCUMENT } from '@angular/common';

export interface IExtentionCountry {
  Country: string;
  CountryIcon: string;
  CountryId: number;
  ExtensionData: object;
}
export interface IMoneySource {
  MoneySource: string;
  MoneySourceId: number;
  ExtensionData: object;
}
@Component({
  selector: 'register-wettarena-pl-component',
  templateUrl: './register-wettarena-pl.component.html',
})
export class RegisterWettarenaPlComponent implements OnInit, AfterViewInit {
  constructor(
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private route: ActivatedRoute,
    private _router: Router,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document
  ) {
    Object.keys(this._LocalizationService.lcData).forEach(key => {
      const _local = {
        isoCode: key.toLocaleLowerCase(),
        nativeName: this._LocalizationService.lcData[key].native,
      };
      this.countryList.push(_local);
    });

    /*const _formData = {};
    this.registerDatasStructure.forEach((x) => {
      if (x.isActive) {
        _formData[x.fname] = new FormControl({ value: x.value, disabled: false }, x.validators);
      }
    });
    this.registerDatas = _FormBuilder.group(_formData);*/

    // this.registerDatas.controls['mail'].disable();

    this.getSignUpFields();
  }

  registerDatas: UntypedFormGroup;
  registerDatasb3Step1: UntypedFormGroup;

  registerIsActive = false;

  picker = [];
  countryList = [];
  currencyList = [];
  countryListAPI = [];
  moneySourceDataArr: Array<IMoneySource>[];

  countryListLangAPI = [];
  countryListExtentionData: Array<IExtentionCountry>[];

  saluteList = [];
  translator = new TranslatePipe(this._LocalizationService);
  EasyPasswordEnabled;
  branchcode = '';

  registerStepB3 = 1;
  mailIsUse = false;
  registerDatasB3Step1Structure = [
    {
      fname: 'mail',
      type: 'input_mail',
      FType: 'input_mail',
      value: '',
      placeholder: this.translator.transform('E_mail', null),
      hint: '',
      errText: this.translator.transform('Please_enter_a_valid_mail_address', null),
      isActive: true,
      validators: [Validators.email, Validators.minLength(3)],
      key: 'fieldemail',
    },
  ];

  registerDatasStructure = [
    {
      FType: 'group_name',
      group: 1,
      text: this.translator.transform('Kontodetails', null),
      isActive: true,
    },
    {
      group: 1,
      fname: 'mailf',
      type: 'input_mail',
      FType: 'input_mail',
      value: '',
      placeholder: this.translator.transform('E_mail', null),
      hint: '',
      errText: this.translator.transform('Required', null),
      isActive: true,
      validators: [Validators.email, Validators.minLength(3)],
      key: 'fieldemail',
    },
    {
      group: 1,
      fname: 'username',
      type: 'input_text_username',
      FType: 'input_text',
      value: '',
      placeholder: this.translator.transform('user_name', null),
      hint: '',
      errText: this.translator.transform('CharacterText', null),
      isActive: true,
      validators: [Validators.minLength(3), Validators.required, Validators.pattern('^[A-Za-z0-9ÄÖÜẞäöüß]+$')],
      key: 'fieldusername',
    },

    {
      group: 1,
      fname: 'password',
      type: 'input_password',
      FType: 'input_password',
      autoComplete: 'new-password',
      value: '',
      placeholder: this.translator.transform('password', null),
      hint: this.translator.transform('Register_Password_Info', null),
      errText: this.translator.transform('Register_Password_Info', null),
      isActive: true,
      validators: [Validators.required, Validators.pattern('^(?=.*[A-Z])(?=.*[!.@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,25}$')],
      key: 'fieldpassword',
    },
    {
      group: 1,
      fname: 're_password',
      type: 'input_password',
      FType: 'input_password',
      autoComplete: 're-password',
      value: '',
      placeholder: this.translator.transform('re_password', null),
      hint: this.translator.transform('Required', null),
      errText: this.translator.transform('Register_Re_Password_Same_Error', null),
      isActive: true,
      validators: [Validators.required, Validators.pattern('^(?=.*[A-Z])(?=.*[!.@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,25}$')],
      key: 'fieldrepassword',
    },
    {
      FType: 'group_name',
      group: 1,
      text: this.translator.transform('Personal_Data', null),
      isActive: true,
    },

    {
      group: 1,
      fname: 'titleId',
      type: 'input_text',
      FType: 'input_hide',
      value: '',
      placeholder: this.translator.transform('l_name', null),
      hint: '',
      errText: this.translator.transform('Required', null),
      isActive: true,
      validators: [Validators.required, Validators.minLength(3)],
      key: 'fieldtitle',
    },
    {
      group: 1,
      fname: 'userFName',
      type: 'input_text_firstname',
      FType: 'input_title_firstname',
      value: '',
      placeholder: this.translator.transform('f_name', null),
      hint: '',
      errText: this.translator.transform('b3000_register_only_letters_and-', null),
      isActive: true,
      validators: [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-ZÄÖÜẞäöüß -]*$')],
      key: 'fieldfirstname',
    },
    {
      group: 1,
      fname: 'userLName',
      type: 'input_text_lastname',
      FType: 'input_text',
      value: '',
      placeholder: this.translator.transform('l_name', null),
      hint: '',
      errText: this.translator.transform('b3000_register_only_letters_and-', null),
      isActive: true,
      validators: [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-ZÄÖÜẞäöüß -]*$')],
      key: 'fieldlastname',
    },
    {
      group: 1,
      fname: 'bday',
      type: 'input_date',
      FType: 'input_date',
      value: '',
      placeholder: this.translator.transform('bday', null),
      hint: '',
      errText: this.translator.transform('Required', null),
      isActive: true,
      validators: [Validators.required, Validators.minLength(3)],
      key: 'fieldbirthday',
    },

    {
      FType: 'group_name',
      group: 2,
      text: this.translator.transform('b3000_contactDetails', null),
      isActive: true,
    },

    // PESEL test no: 75120804355
    // {
    //   group: 2,
    //   fname: 'passportnumber',
    //   type: 'input_text',
    //   FType: 'input_text',
    //   value: '',
    //   placeholder: this.translator.transform('pesel', null),
    //   hint: '',
    //   errText: this.translator.transform('Required', null),
    //   isActive: true,
    //   validators: [
    //     Validators.required,
    //     Validators.pattern('^[0-9]{2}([02468]1|[13579][012])(0[1-9]|1[0-9]|2[0-9]|3[01])[0-9]{5}$')
    //   ],
    //   key: 'passportnumber',
    // },

    {
      group: 2,
      fname: 'phonecodeid',
      type: 'input_phonecode',
      FType: 'input_phoneC_phone',
      value: '',
      placeholder: this.translator.transform('Phone_Code', null),
      placeholder2: this.translator.transform('b3000_register_phone_number_optional', null),
      hint: '',
      errText: this.translator.transform('Required', null),
      errText2: this.translator.transform('b3000_register_numbers_only', null),
      isActive: true,
      validators: [Validators.required, Validators.required],
      key: 'fieldphonecode',
    },
    {
      group: 2,
      fname: 'phone',
      type: 'input_phone',
      FType: 'input_hide',
      value: '',
      placeholder: this.translator.transform('b3000_register_phone_number_optional', null),
      hint: '',
      errText: this.translator.transform('Required', null),
      isActive: true,
      validators: [Validators.pattern('^[0-9]*$')],
      key: 'fieldphone',
    },
    {
      group: 2,
      fname: 'prefferedLang',
      type: 'input_langID',
      FType: 'input_languageP',
      value: '',
      placeholder: this.translator.transform('prefered_language', null),
      hint: '',
      errText: this.translator.transform('Required', null),
      isActive: true,
      validators: [Validators.required, Validators.minLength(3)],
      key: 'fieldlang',
    },
    {
      group: 2,
      fname: 'isBonus',
      type: 'input_bonusAggrement',
      FType: 'checkboxClick2',
      value: false,
      errText: this.translator.transform('Required', null),
      isActive: true,
      validators: [],
      key: 'fieldcontract',
    },

    {
      group: 2,
      fname: 'promotion_permission',
      type: 'input_slide_promotion_permission',
      FType: 'input_checkbox',
      value: false,
      placeholder: this.translator.transform('b3000_Register_checkbox_text_3', null),
      hint: this.translator.transform('Required', null),
      errText: '',
      isActive: true,
      validators: [Validators.required],
      key: 'fieldpromotion',
    },
    // {
    //   group: 2,
    //   fname: "agreement",
    //   type: "input_slide_agreement",
    //   FType: "input_checkbox",
    //   value: false,
    //   placeholder: this.translator.transform(
    //     "b3000_Register_checkbox_text_2",
    //     null
    //   ),
    //   hint: "",
    //   errText: this.translator.transform("Required", null),
    //   isActive: true,
    //   validators: [Validators.requiredTrue],
    //   key: "fieldcontract",
    // },

    {
      group: 2,
      fname: 'currencyid',
      type: 'input_currency',
      FType: 'input_hide',
      value: '',
      placeholder: this.translator.transform('currency', null),
      hint: '',
      errText: this.translator.transform('Required', null),
      isActive: true,
      validators: [Validators.minLength(3)],
      key: 'fieldcurrency',
    },

    {
      group: 2,
      fname: 'agreement',
      type: 'input_slide_agreement',
      FType: 'checkboxClick',
      value: false,
      errText: this.translator.transform('Required', null),
      isActive: true,
      validators: [Validators.requiredTrue],
      key: 'fieldcontract',
    },

    {
      FType: 'submit',
      group: 2,
      isActive: true,
    },
  ];

  registerDataValues;

  PhoneNumberList = [];
  langDatas = {};
  langDatasArry = [];

  ngOnInit(): void {
    this.EasyPasswordEnabled = EasyPasswordEnabled;

    this.route.params.subscribe(params => {
      if (params['branchcode'] != undefined) {
        this.branchcode = params['branchcode'];
      }
    });

    // const iacookies = JSON.parse(localStorage.getItem("IACokiees"));

    const iacookies = JSON.parse(this.getCookie('IACokiees'));

    this.route.queryParams.subscribe(params => {
      if (params != undefined) {
        if (params.ia_affid || params.btag || params.siteid) {
          if (iacookies == null) {
            localStorage.setItem(
              'IACokiees',
              JSON.stringify({
                ia_affid: params.ia_affid,
                btag: params.btag,
                siteid: params.siteid,
                playerid: params.playerid,
                timeStamp: iacookies.timeStamp ? iacookies.timeStamp : new Date().getTime(),
              })
            );
            const ObjAffilation = {
              btag: params.btag,
              ia_affid: params.ia_affid,
              siteId: params.siteid,
              timeStamp: iacookies.timeStamp ? iacookies.timeStamp : new Date().getTime(),
            };
            const ObjAffilation2 = JSON.stringify(ObjAffilation);
            this.setCookie('IACokiees', ObjAffilation2, 30);
          }
        }
      }
    });

    if (iacookies) {
      if (iacookies.ia_affid) {
        const date = iacookies.timeStamp;
        const yesterday = Math.round(new Date().getTime() / 1000) - 24 * 3600;

        if (yesterday < date) {
          this.branchcode = iacookies.ia_affid;
        }
      }
    }

    this.langDatas = this._LocalizationService.langDatas;
    Object.keys(this.langDatas).forEach(x => {
      this.langDatasArry.push(this.langDatas[x]);
    });
    // this.registerDatas.controls.prefferedLang.setValue(55);
  }

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) {
      this._UiHelper.setRightMenu();
    }
  }

  getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  SnackSupport() {
    const translator = new TranslatePipe(this._LocalizationService);
    const t_message = translator.transform('errorcodeRegister1', null);
    const t_message2 = translator.transform('errorcodeRegister2', null);

    const navigateLink = 'https://help-center.bet3000.de/hc/de/sections/360005881118-Registrierung';
    this._UiHelper.errorSnackBarWithAction(t_message, t_message2, navigateLink);
  }

  signUp() {
    this._UiHelper.setLoadingDialog(true);
    const translator = new TranslatePipe(this._LocalizationService);
    if (environment.IsBet3000 && this.registerDatas.valid) {
      // console.warn(this.registerDataValues);

      // aggrement alanı true hiç olmuyor o yüzden kontrol yapılamıyor
      // if (!this.registerDataValues.aggrement) {
      //  const t_message = translator.transform('register_contract', null);
      //  this._UiHelper.errorSnackBar(t_message, '');
      //  this._UiHelper.setLoadingDialog(false);
      //  return;
      // }
      this._ApiService.signUpB3(this.registerDataValues).then(result => {
        this._UiHelper.setLoadingDialog(false);
        if (result.code == 'error') {
          pushToDataLayer({ event: 'verification_failed' });
          pushToDataLayer({ event: 'sign_up_failed', error: result.code });
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          pushToDataLayer({ event: 'verification_failed' });
          pushToDataLayer({ event: 'sign_up_failed', error: result.code });

          const t_message = translator.transform(result.message, null);
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'error2') {
          pushToDataLayer({ event: 'verification_failed' });
          pushToDataLayer({ event: 'sign_up_failed', error: result.code });
          this.SnackSupport();
        } else if (result.code == 'success') {
          pushToDataLayer({ event: 'sign_up' });
          pushToDataLayer({ event: 'verification_success' });
          const t_message = translator.transform(result.message, null);
          this._UiHelper.successSnackBar(t_message, '');

          // const iacookies = JSON.parse(localStorage.getItem("IACokiees"));
          const iacookies = JSON.parse(this.getCookie('IACokiees'));
          if (iacookies) {
            if (iacookies.ia_affid) {
              this._ApiService.saveAffiliation('', iacookies).then(result => {
                localStorage.removeItem('IACokiees');
              });
            }
          }

          this._router.navigate(['/registersuccess']);
        } else {
          pushToDataLayer({ event: 'sign_up_failed', error: 'unhandled' });
          this._UiHelper.setLoadingDialog(false);
        }
      });
    } else {
      this._ApiService.signUp(this.registerDataValues).then(result => {
        this._UiHelper.setLoadingDialog(false);
        ////// console.log("SİGN_UP_result", result);
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          const t_message = translator.transform(result.message, null);
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'error2') {
          const t_message = translator.transform(result.message, null);
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          const t_message = translator.transform(result.message, null);
          this._UiHelper.successSnackBar(t_message, '');

          this._router.navigate(['/registersuccess']);
        }
      });
    }
  }

  getCurrencyList() {
    this._ApiService.getCurrencyList().then(result => {
      if (result == undefined) {
        return;
      }
      if (result == '') {
        return;
      }

      this.currencyList = result;
    });
  }

  goLogin() {
    this._UiHelper.loginDropDownOpen();
  }

  getCountryList() {
    this._ApiService.getCountryList().then(result => {
      this.countryListAPI = result;
    });
  }
  getMoneySourceList() {
    this._ApiService.getMoneySourceList().then(result => {
      this.moneySourceDataArr = result;
    });
  }

  getCountryListLang() {
    this._ApiService.getCountryListLang().then(result => {
      this.countryListLangAPI = result;

      // this.registerDatas.controls.country.setValue(55);
      // this.registerDatas.controls.countryOfBirth.setValue(55);
      // this.registerDatas.controls.nationalty.setValue(55);
    });
  }

  getExtentionCountryList() {
    this._ApiService.getExtentionCountryList().then(result => {
      this.countryListExtentionData = result;
    });
  }

  getSaluteList() {
    this._ApiService.getSaluteList().then(result => {
      this.saluteList = result;
      this.registerDatas.controls.titleId.setValue(2);
    });
  }

  getComboPhoneNumberList() {
    this._ApiService.getComboPhoneNumberList().then(PhoneNumberList => {
      this.PhoneNumberList = PhoneNumberList;
      this.registerDatas.controls.phonecodeid.setValue(151);
      this.registerDatas.controls.prefferedLang.setValue(6);
    });
  }

  checkMailAddressUsage() {
    const mail = this.registerDatasb3Step1.value.mail;
    this._ApiService.checkEmailUsage(mail).then(result => {
      if (result && result.resultcode === 100) {
        pushToDataLayer({ event: 'sign_up_email_success' });
        this.registerStepB3 = 2;
        this.registerDatas.controls.mailf.setValue(mail);
        this.registerDatas.controls.mailf.disable();
        this.loadLoqateScript();
      } else {
        this.mailIsUse = true;
      }
    });
  }

  getSignUpFields() {
    this._ApiService.getSignUpFields().then(result => {
      let rds = this.registerDatasStructure as Array<any>;
      let rdsRebuild = [];

      rds = rds
        .map(x => {
          if (!environment.IsBet3000) {
            const fieldobj = result.find(t => x.key == t.FieldName);
            if (fieldobj != undefined) {
              ////// console.log(fieldobj);
              x.isActive = fieldobj.IsVisible;
              if (fieldobj.IsRequired) {
                x.validators.push(Validators.required);
              }
              return x;
            }
            return false;
          } else {
            // if project is Bet3000 pass true for no validate from api.
            return x;
          }
        })
        .filter(x => x.isActive);

      if (this.EasyPasswordEnabled) {
        const passwordField = rds.filter(t => 'password' == t.fname)[0];
        passwordField.validators.splice(0, 2);
        passwordField.validators.push(Validators.required);
        passwordField.validators.push(Validators.pattern('^.{5,35}$'));

        const repasswordField = rds.filter(t => 're_password' == t.fname)[0];
        repasswordField.validators.splice(0, 2);
        repasswordField.validators.push(Validators.required);
        repasswordField.validators.push(Validators.pattern('^.{5,35}$'));
      }

      // For bet3000 form fields need to be regrouping array.
      if (environment.IsBet3000) {
        const _newRds = {};
        rds.forEach(formItem => {
          if (!_newRds[formItem.group]) {
            _newRds[formItem.group] = {
              data: [],
            };
          }
          _newRds[formItem.group].data.push(formItem);

          if (formItem.FType === 'group_name') {
            _newRds[formItem.group] = {
              ...formItem,
              ..._newRds[formItem.group],
            };
          }
        });

        rdsRebuild = Object.keys(_newRds).map(i => _newRds[i]);
      }
      this.registerDatasStructure = rds;

      const _formData = {};
      rds.forEach(x => {
        if (x.isActive) {
          _formData[x.fname] = new UntypedFormControl({ value: x.value, disabled: false }, x.validators);
        }
      });
      const _formDataB3Step1 = {};
      if (environment.IsBet3000) {
        this.registerDatasB3Step1Structure.forEach(x => {
          if (x.isActive) {
            _formDataB3Step1[x.fname] = new UntypedFormControl({ value: x.value, disabled: false }, x.validators);
          }
        });
        this.registerDatasStructure = rdsRebuild;
      }

      _formData['privacyPolicy'] = new UntypedFormControl({ value: false, disabled: false }, [Validators.required]);

      if (this.branchcode != undefined && this.branchcode != '') {
        _formData['bayi'] = new UntypedFormControl({ value: this.branchcode, disabled: false }, []);
      } else {
        _formData['bayi'] = new UntypedFormControl({ value: 1, disabled: false }, []);
      }

      this.registerDatas = this._FormBuilder.group(_formData);
      this.registerDatasb3Step1 = this._FormBuilder.group(_formDataB3Step1);
      this.registerDatas.valueChanges.subscribe(x => {
        const zipControls = this.registerDatas.controls['zip'];

        if (x.password != x.re_password) {
          this.registerDatas.controls['re_password'].setErrors({
            incorrect: true,
          });
        }

        this.registerDataValues = this.registerDatas.getRawValue();
      });

      this.getCurrencyList();
      this.getSaluteList();
      this.getCountryList();
      this.getCountryListLang();
      this.getExtentionCountryList();
      this.getComboPhoneNumberList();
      this.getMoneySourceList();
    });
  }

  private setCookie(name: string, value: string, expireDays: number, path = '') {
    const d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 1 * 60 * 24 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    const cpath = `; path=/`;
    const domain = 'Domain=bet3000.de';
    document.cookie = `${name}=${value};  ${expires}${cpath}; `;
    // console.warn("Cookie",document.cookie);
  }

  // Form Control does not detect extarnal changes.
  // So we need to manually set changes.
  reAssignValues() {
    const addressInput: HTMLInputElement = document.getElementById('address') as HTMLInputElement;
    const cityInput: HTMLInputElement = document.getElementById('city') as HTMLInputElement;
    const zipInput: HTMLInputElement = document.getElementById('zip') as HTMLInputElement;
    const housenumberInput: HTMLInputElement = document.getElementById('housenumber') as HTMLInputElement;

    if (addressInput && addressInput.value !== this.registerDatas.controls['address'].value) {
      this.registerDatas.controls['address'].setValue(addressInput.value);
    }
    if (cityInput && cityInput.value !== this.registerDatas.controls['city'].value) {
      this.registerDatas.controls['city'].setValue(cityInput.value);
    }
    if (zipInput && zipInput.value !== this.registerDatas.controls['zip'].value) {
      this.registerDatas.controls['zip'].setValue(zipInput.value);
    }
    if (housenumberInput && housenumberInput.value !== this.registerDatas.controls['housenumber'].value) {
      this.registerDatas.controls['housenumber'].setValue(housenumberInput.value);
    }
  }

  loadLoqateScript() {
    ((n, t, i, r) => {
      let u, f;
      (n[i] = n[i] || {}),
        (n[i].initial = {
          accountCode: 'BETDE11112',
          host: 'BETDE11112.pcapredict.com',
        }),
        (n[i].on =
          n[i].on ||
          function () {
            // eslint-disable-next-line prefer-rest-params
            (n[i].onq = n[i].onq || []).push(arguments);
          }),
        (u = t.createElement('script')),
        (u.async = !0),
        (u.src = r),
        (f = t.getElementsByTagName('script')[0]),
        f.parentNode.insertBefore(u, f);

      n[i].on('load', (type, id, control) => {
        control.listen('populate', (address, variations) => {
          this.reAssignValues();
        });
      });
    })(window, document, 'pca', '//BETDE11112.pcapredict.com/js/sensor.js');
  }
}
